import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export const APPL_ACTIVITY_LIST_QUERY_KEY = ["appl-activity-list"];

export const applActivityListService = {
    getActivityList: async () => 
        requestWithRefresh(() =>
        api
            .get(`api/appl-activity-list`, {
            headers: getAuthHeaders(),
            })
            .then((res) => res.data),
        ),
};